import SearchField from '@amzn/meridian/search-field';
import { type FC, useCallback } from 'react';
import { useJagListViewContext } from '../JagListViewContext';

export const JagListViewSearch: FC = () => {
  const { localSearchQuery, setLocalSearchQuery, setSearchQuery } = useJagListViewContext();

  const handleSubmit = useCallback(
    (query: string) => {
      setSearchQuery(query);
    },
    [
      setSearchQuery,
    ],
  );

  const handleChange = useCallback(
    (query: string) => {
      setLocalSearchQuery(query);
    },
    [
      setLocalSearchQuery,
    ],
  );

  const handleClear = useCallback(() => {
    setLocalSearchQuery('');
    handleSubmit('');
  }, [
    handleSubmit,
    setLocalSearchQuery,
  ]);

  return (
    <SearchField
      clearButton
      data-cy="jags-search-field"
      data-testid="jags-search-field"
      onChange={handleChange}
      onClear={handleClear}
      onSubmit={handleSubmit}
      placeholder="Search for an asset group"
      value={localSearchQuery}
      width="100%"
    />
  );
};
